import { Container } from '@twisto/components/atoms/container'

import { PeriodSlider } from '../period-slider'

import * as styles from './installments-schedule-picker.styles'

type Props = {
  value: number
  onChange: (value: number) => void
  min: number
  max: number
}
export const InstallmentsSchedulePicker = ({
  value,
  min,
  max,
  onChange,
}: Props) => (
  <div css={styles.pickSection}>
    <Container noPadding size="tiny">
      <PeriodSlider max={max} min={min} value={value} onChange={onChange} />
    </Container>
  </div>
)
